import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import { isRunningInFront } from "../../../services/front";
import { auth } from "../../../services/GoogleAuth";

const AuthRoute = ({ children }) => {
  const location = useLocation();

  if (isRunningInFront) {
    // Passing a random key to force rendering on the same path
    // Useful when receiving same email on different inboxes in Front
    return React.cloneElement(children, { key: Date.now() });
  } else {
    if (auth.isSignedIn()) {
      return children;
    } else {
      return (
        <Navigate
          to={{
            pathname: "/login",
            search: `?redirectPath=${encodeURIComponent(location.pathname)}`
          }}
          replace
        />
      );
    }
  }
};

export default AuthRoute;
